// @flow
import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Button, Modal } from 'semantic-ui-react';
import PersonaModal from './PersonaModal';
import type { AcfFields } from '../types/personas';
import Link from './Link';
import { Link as RouterLink } from 'react-router-dom';

type Props = {
  colour: string,
  image: string,
  title: string,
  summary: string,
  communityImageGallery?: [
    {
      url: string,
      alt: string,
      title: string,
    },
  ],
  personas?: [],
  acf: AcfFields,
  clearSlug: Function,
  persona_slug?: string,
  /* Specifies an overwrite URL for the default button behaviour */
  buttonLinkOverride?: string,
  /* Specifies the slug of the personas so we can toggle between NZ and AU */
  personaSlugOverride?: string,
  /* Specifies if the button link should open in a new tab */
  buttonLinkExternal?: boolean,
  /* Specifies if the title should replace `-` characters with `<br/>` tags */
  replaceWithBreaks?: boolean,
  hideReadMore?: boolean,
  country: string
};

class CommunityTile extends React.Component<Props> {
  render(): React.Element<"div"> {
    const {
      colour,
      image,
      title,
      summary,
      communityImageGallery,
      personas,
      acf,
      persona_slug,
      clearSlug,
      buttonLinkOverride,
      personaSlugOverride,
      buttonLinkExternal,
      replaceWithBreaks,
      country
    } = this.props;

    const buttonLink = buttonLinkOverride
      ? buttonLinkOverride
      : '/products/helix-personas/' +
        title
          .toLowerCase()
          .replace(' - ', '-')
          .replace(' ', '-')
          .replace(' ', '-');


    const personaSlug = personaSlugOverride
      ? "/products/" + personaSlugOverride + "/"
      : '/products/helix-personas/';
          

    const formattedTitle = replaceWithBreaks
      ? title.replace('-', '<br/>')
      : title;

    const buttonExternal = buttonLinkExternal ? '_blank' : '';
    
    return (
      <div className="community-tile" style={{ backgroundColor: colour }}>
        <img className="community-tile__image" src={image} alt="" />
        <div className="community-tile__text">
          <h4>{ReactHtmlParser(formattedTitle)}</h4>
          <div className="community-tile__text-wrapper">
            {ReactHtmlParser(summary)}
          </div>
          <Modal
            open={
              persona_slug ===
              title
                .toLowerCase()
                .replace(' - ', '-')
                .replace(' ', '-')
                .replace(' ', '-')
            }
            trigger={
              <Link 
                url={buttonLink} 
                target={buttonExternal}>
                <div
                  className="community-tile__button-container"
                  style={{ color: colour }}
                >
                  {this.props.hideReadMore ? (
                    ''
                  ) : (
                    <Button className="button--hollow">Read More</Button>
                  )}
                </div>
              </Link>
            }
            closeIcon={
              <button className="modal__close" onClick={clearSlug}>
                Close
              </button>
            }
          >
            <PersonaModal
              // $FlowFixMe
              images={communityImageGallery}
              acf={acf}
              link={`personas/${acf.personacommunityNumber}`}
              country={country}
            />
          </Modal>
        </div>
        <div className="community-tile-menu">
          {personas &&
            personas
              .slice(0)
              .sort((a, b) => {
                // non-anonymous as you ordered...
                return b.acf.personacommunityNumber <
                  a.acf.personacommunityNumber
                  ? 1 // if b should come earlier, push a to end
                  : b.acf.personacommunityNumber > a.acf.personacommunityNumber
                  ? -1 // if b should come later, push a to begin
                  : 0; // a and b are equal
              })
              .map((persona, key) => (
                <div key={key}>
                  <Modal
                    open={
                      persona_slug ===
                      persona.acf.personacommunityNumber +
                        '-' +
                        persona.acf.title
                          .toLowerCase()
                          .replace(' - ', '-')
                          .replace(' ', '-')
                          .replace(' ', '-')
                          .replace(' ', '-')
                    }
                    className="community-title-menu__persona-link"
                    trigger={
                      <RouterLink
                        to={
                          personaSlug +
                          persona.acf.personacommunityNumber +
                          '-' +
                          persona.acf.title
                            .toLowerCase()
                            .replace(' ', '-')
                            .replace(' ', '-')
                            .replace(' ', '-')
                        }
                      >
                        <div className="community-tile-menu__link">
                          <span className="community-tile-menu__number">
                            {persona.acf.personacommunityNumber}
                          </span>
                          <span className="community-tile-menu__name">
                            {persona.acf.title}
                          </span>
                        </div>
                      </RouterLink>
                    }
                    closeIcon={
                      <button className="modal__close" onClick={clearSlug}>
                        Close
                      </button>
                    }
                  >
                    <PersonaModal
                      images={persona.knowMeImageGallery}
                      acf={persona.acf}
                      country={country}
                      link={`personas/${
                        persona.acf.personacommunityNumber
                      }/know-me`}
                    />
                  </Modal>
                </div>
              ))}
        </div>
      </div>
    );
  }
}

export default CommunityTile;
